import { render, staticRenderFns } from "./AdminLicensesTable.vue?vue&type=template&id=b4486a90"
import script from "./AdminLicensesTable.vue?vue&type=script&lang=js"
export * from "./AdminLicensesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4486a90')) {
      api.createRecord('b4486a90', component.options)
    } else {
      api.reload('b4486a90', component.options)
    }
    module.hot.accept("./AdminLicensesTable.vue?vue&type=template&id=b4486a90", function () {
      api.rerender('b4486a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminLicensesTable.vue"
export default component.exports